import http from "../common/services/httpService";
import { AxiosResponse } from "axios";
import queryString from "query-string";

import { InsurerBranchInputDto, InsurerBranchSearchResultDto } from "../interfaces/admin/InsurerBranch";
import { Nomenclature } from "../common/components/mui-extended/SelectExtended";

const apiEndpoint = "/insurerBranch";

const getInsurerBranchesAsync = async (query: string): Promise<AxiosResponse<Array<InsurerBranchSearchResultDto>>> => {
  return await http.get<Array<InsurerBranchSearchResultDto>>(`${apiEndpoint}?${query}`);
};

const getInsurerBranchesCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpoint}/count?${query}`);
};

const getInsurerBranchAsync = async (id: number): Promise<AxiosResponse<InsurerBranchInputDto>> => {
  return await http.get<InsurerBranchInputDto>(`${apiEndpoint}/${id}`);
};

const addInsurerBranchAsync = async (model: InsurerBranchInputDto): Promise<AxiosResponse<InsurerBranchInputDto>> => {
  return await http.post<InsurerBranchInputDto>(apiEndpoint, model);
};

const updateInsurerBranchAsync = async (
  model: InsurerBranchInputDto
): Promise<AxiosResponse<InsurerBranchInputDto>> => {
  return await http.put<InsurerBranchInputDto>(`${apiEndpoint}/${model.insurerBranchId}`, model);
};

const getInsurerBranchIdByNameAndParentIdAsync = async (
  name: string,
  parentId?: number
): Promise<AxiosResponse<number | null>> => {
  return await http.get<number | null>(`${apiEndpoint}/idByNameAndParentId?name=${name}&parentId=${parentId}`);
};

const getInsurerBranches = async (
  offset: number = 0,
  limit: number = Number.MAX_SAFE_INTEGER,
  keyword: string = "",
  parentId?: number
): Promise<AxiosResponse<Array<Nomenclature>>> => {
  if (parentId) {
    return await http.get<Array<Nomenclature>>(
      `${apiEndpoint}/nomenclature/search?offset=${offset}&limit=${limit}&keyword=${keyword}&parentId=${parentId}`
    );
  }

  return Promise.resolve({ data: new Array<Nomenclature>() } as AxiosResponse);
};

const getInsurerBranchesByIds = async (ids: Array<number>): Promise<AxiosResponse<Array<Nomenclature>>> => {
  const queryStringIds = queryString.stringify({ ids }, { arrayFormat: "index" });
  return await http.get<Array<Nomenclature>>(`${apiEndpoint}/nomenclature/init?${queryStringIds}`);
};

export default {
  getInsurerBranchesAsync,
  getInsurerBranchesCountAsync,
  getInsurerBranchAsync,
  addInsurerBranchAsync,
  updateInsurerBranchAsync,
  getInsurerBranchIdByNameAndParentIdAsync,
  getInsurerBranches,
  getInsurerBranchesByIds,
};
